import type {
    FixedPriceProjectProduct,
    FixedPriceProjectProductGroupKey,
    ProductGroupConfig,
} from '../../types';

export const productGroupsConfig: Record<FixedPriceProjectProductGroupKey, ProductGroupConfig> = {
    'logo-essential': {
        name: 'logo-essential',
        designInspirationCategoryKey: 'logo-design',
    },
    'logo-essential-and-consultation': {
        name: 'essential-logo-consult',
        designInspirationCategoryKey: 'logo-design',
    },
    'full-service-branding': {
        name: 'full-service-branding',
        designInspirationCategoryKey: 'brand-identity-pack',
    },
    'business-card-design': {
        name: 'business-card-design',
        designInspirationCategoryKey: '', //TODO this is a hack to force no inspiration to come back, because we can't use 99d designs as inspo for CARE products
    },
    'brand-guide': {
        name: 'brand-guide-essential',
        designInspirationCategoryKey: 'brand-guide',
        relatedProductsNames: [
            'bronze-logo-brand-guide-contest',
            'bronze-logo-brand-identity-pack-contest',
            'bronze-logo-contest',
        ],
    },
    'brochure-essential': {
        name: 'brochure-essential',
        designInspirationCategoryKey: 'brochure-design',
        relatedProductsNames: [
            'postcard-flyer-essential',
            'business-card-essential',
            'bronze-logo-brand-identity-pack-contest',
        ],
    },
    'brochure-design': {
        name: 'brochure-design',
        designInspirationCategoryKey: 'brochure-design',
    },
    'menu-design': {
        name: 'menu-design',
        designInspirationCategoryKey: 'menu-design',
    },
    'flyer-design': {
        name: 'flyer-design',
        designInspirationCategoryKey: 'flyer-design',
    },
    'postcard-design': {
        name: 'postcard-design',
        designInspirationCategoryKey: 'postcard-design',
    },
    'vinyl-banner-design': {
        name: 'vinyl-banner-design',
        designInspirationCategoryKey: 'vinyl-banner-design',
    },
    'business-card-essential': {
        name: 'business-card-essential',
        designInspirationCategoryKey: 'business-card-design',
        relatedProductsNames: [
            'bronze-logo-business-card-contest',
            'bronze-logo-brand-identity-pack-contest',
            'brochure-essential',
        ],
    },
    'postcard-flyer-essential': {
        name: 'postcard-flyer-essential',
        designInspirationCategoryKey: 'postcard-flyer-design',
        relatedProductsNames: [
            'brochure-essential',
            'bronze-logo-brand-identity-pack-contest',
            'business-card-essential',
        ],
    },
    'social-media-brand-pack': {
        name: 'social-media-branding',
        designInspirationCategoryKey: 'social-media-page-design',
    },
    'business-starter-pack': {
        name: 'brand-identity-pack',
        designInspirationCategoryKey: 'logo-business-card-design',
    },
};

export const additionalProductGroupAttributes: Record<
    FixedPriceProjectProductGroupKey,
    Partial<FixedPriceProjectProduct>
> = {
    'logo-essential': { createBriefProductKey: 'logo-essential' },
    'business-card-design': {
        createBriefProductKey: 'business-card-design',
    },
    'logo-essential-and-consultation': {},
    'full-service-branding': {
        secondaryCTALink: 'https://calendly.com/laura-circlemaker/brand-consult',
    },
    'brand-guide': {},
    'brochure-essential': {},
    'business-card-essential': {},
    'postcard-flyer-essential': {},
    'social-media-brand-pack': {},
    'business-starter-pack': {},

    'brochure-design': {
        createBriefProductKey: 'care-design',
    },
    'menu-design': {
        createBriefProductKey: 'care-design',
    },
    'flyer-design': {
        createBriefProductKey: 'care-design',
    },
    'postcard-design': {
        createBriefProductKey: 'care-design',
    },
    'vinyl-banner-design': {
        createBriefProductKey: 'care-design',
    },
};
